import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/valentines.css'
import App from './App.jsx'
import './i18n/i18n'
import { initEverflow } from './utils/everflow'

initEverflow()

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.warn = () => {}
  console.error = () => {}
  console.info = () => {}
  console.debug = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
